import React, { useEffect, useState } from "react";
import { Carousel } from "antd";
import axios from "../../utils/request";
import "./index.css";
interface IProps {
  isShowBtn?: boolean;
}
const Banner = (props: IProps) => {
  const { isShowBtn } = props;
  const [banners, setBanners] = useState<any>([]);
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/index/banner");
      if (res.code === 200) {
        setBanners(res.data);
      }
    };
    initData();
  }, []);
  return (
    <div className="banner">
      {banners.length ? (
        <Carousel
          dots={{ className: "dot-css" }}
          effect="fade"
          autoplay={true}
          speed={1000}
          draggable={true}
          autoplaySpeed={5000}
          adaptiveHeight={true}
        >
          {banners.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="banner-li"
                onClick={() => {
                  window.open(`${item.url}`, "_blank");
                }}
              >
                <img className="banner-img" src={item.img} alt="banner" />
              </div>
            );
          })}
        </Carousel>
      ) : null}

      {/* {isShowBtn && (
        <div className="banner-container">
          <div className="bc-li">
            <img
              className="bc-li-img"
              src="/images/1-2011261H61XD.jpg"
              alt="图标"
            />
            <div className="bc-li-right">
              <div className="bc-li-r-title">解决方案</div>
              <div className="bc-li-r-desc">跨行业跨领域的数字化解决方案</div>
            </div>
          </div>
          <div className="bc-li">
            <img
              className="bc-li-img"
              src="/images/1-2011261H61XD.jpg"
              alt="图标"
            />
            <div className="bc-li-right">
              <div className="bc-li-r-title">解决方案</div>
              <div className="bc-li-r-desc">跨行业跨领域的数字化解决方案</div>
            </div>
          </div>
          <div className="bc-li">
            <img
              className="bc-li-img"
              src="/images/1-2011261H61XD.jpg"
              alt="图标"
            />
            <div className="bc-li-right">
              <div className="bc-li-r-title">解决方案</div>
              <div className="bc-li-r-desc">跨行业跨领域的数字化解决方案</div>
            </div>
          </div>
          <div className="bc-li">
            <img
              className="bc-li-img"
              src="/images/1-2011261H61XD.jpg"
              alt="图标"
            />
            <div className="bc-li-right">
              <div className="bc-li-r-title">解决方案</div>
              <div className="bc-li-r-desc">跨行业跨领域的数字化解决方案</div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};
export default Banner;
